// Curated dropdown options for the company-basics step. Free-text "Other…" is
// always available via SelectOrOther, so these lists need not be exhaustive.

export const SECTORS = [
  "Agriculture & Food",
  "Automotive & Mobility",
  "Construction & Real Estate",
  "Consumer Goods & Retail",
  "Education",
  "Energy & Utilities",
  "Financial Services & Insurance",
  "Government & Public Sector",
  "Healthcare & Life Sciences",
  "Hospitality, Travel & Leisure",
  "Industrial & Manufacturing",
  "Legal Services",
  "Logistics & Transportation",
  "Media & Entertainment",
  "Nonprofit & NGO",
  "Professional Services",
  "Technology & Software",
  "Telecommunications",
];

// Subsectors keyed by sector. Sectors without an entry fall back to free text.
export const SUBSECTORS: Record<string, string[]> = {
  "Agriculture & Food": [
    "Farming & crops",
    "Food & beverage production",
    "AgTech",
    "Distribution & wholesale",
  ],
  "Automotive & Mobility": [
    "Vehicle manufacturing",
    "Parts & suppliers",
    "Dealerships & aftermarket",
    "Mobility services",
  ],
  "Construction & Real Estate": [
    "Construction & engineering",
    "Commercial real estate",
    "Residential real estate",
    "Property management",
    "PropTech",
  ],
  "Consumer Goods & Retail": [
    "Apparel & fashion",
    "Food & grocery retail",
    "E-commerce / D2C",
    "Consumer electronics",
    "Specialty retail",
  ],
  Education: ["K-12", "Higher education", "EdTech", "Corporate training"],
  "Energy & Utilities": ["Oil & gas", "Renewables", "Power & utilities", "Water & waste"],
  "Financial Services & Insurance": [
    "Banking",
    "Insurance",
    "Asset & wealth management",
    "Payments",
    "FinTech",
    "Capital markets",
  ],
  "Government & Public Sector": [
    "Central government",
    "Local government",
    "Defense & security",
    "Public agencies",
  ],
  "Healthcare & Life Sciences": [
    "Providers & hospitals",
    "Payers & insurers",
    "Pharmaceuticals",
    "Medical devices",
    "Biotech",
    "HealthTech / digital health",
  ],
  "Hospitality, Travel & Leisure": [
    "Hotels & lodging",
    "Airlines & travel",
    "Food service & restaurants",
    "Events & attractions",
  ],
  "Industrial & Manufacturing": [
    "Discrete manufacturing",
    "Process manufacturing",
    "Aerospace & defense",
    "Chemicals",
    "Industrial equipment",
  ],
  "Legal Services": ["Law firm", "In-house legal", "LegalTech"],
  "Logistics & Transportation": [
    "Freight & shipping",
    "Warehousing & fulfillment",
    "Last-mile delivery",
    "Passenger transport",
  ],
  "Media & Entertainment": [
    "Publishing",
    "Broadcasting & streaming",
    "Gaming",
    "Advertising & marketing",
    "Music & audio",
  ],
  "Nonprofit & NGO": [
    "Foundations & grantmaking",
    "Charities & social services",
    "Advocacy & membership",
  ],
  "Professional Services": [
    "Management consulting",
    "Accounting & audit",
    "Architecture & engineering",
    "Marketing & creative agency",
    "Recruiting & staffing",
    "IT services",
  ],
  "Technology & Software": [
    "B2B SaaS",
    "Consumer apps",
    "Infrastructure & developer tools",
    "Hardware & devices",
    "AI / ML",
    "Cybersecurity",
  ],
  Telecommunications: ["Network operators", "Equipment & infrastructure", "Internet & broadband"],
};

export const GEOGRAPHIES = [
  "North America",
  "Latin America",
  "Europe (EU)",
  "United Kingdom & Ireland",
  "Middle East & North Africa",
  "Sub-Saharan Africa",
  "South Asia",
  "Southeast Asia",
  "East Asia",
  "Oceania",
  "Global / Multi-region",
];

export const BUSINESS_MODELS = [
  "B2B SaaS / subscription software",
  "B2C subscription",
  "Marketplace / platform",
  "E-commerce / D2C",
  "Retail (physical)",
  "Manufacturing / product sales",
  "Professional services / consulting",
  "Agency",
  "Managed services",
  "Franchise",
  "Advertising / media",
  "Lending / financial services",
  "Licensing / IP",
  "Transactional / brokerage",
  "Nonprofit / grant-funded",
];

export const ROLES = [
  "CEO / Founder",
  "COO",
  "CFO",
  "CTO / CIO",
  "Chief Digital / AI Officer",
  "CMO",
  "Chief Strategy Officer",
  "VP / Head of Strategy",
  "VP / Head of Operations",
  "VP / Head of Product",
  "VP / Head of Technology",
  "Director / Manager",
  "Consultant / Advisor",
];

export const COMPANY_SIZES = [
  { value: "micro", label: "Micro (1 to 9 employees)" },
  { value: "small", label: "Small (10 to 49 employees)" },
  { value: "medium", label: "Medium (50 to 249 employees)" },
  { value: "large", label: "Large (250 to 999 employees)" },
  { value: "enterprise", label: "Enterprise (1,000 to 9,999 employees)" },
  { value: "global_enterprise", label: "Global enterprise (10,000+ employees)" },
];
